import React from 'react';
import cn from 'classnames';
import { Button } from '@alfalab/core-components-button/esm';
import { CrossCircleMIcon } from '@alfalab/icons-glyph/CrossCircleMIcon';

var defaultColors = {"clearIcon":"input__clearIcon_v42u0"};
require('./default.css')

var styles = {"clearIcon":"input__clearIcon_ydl5f","clearButton":"input__clearButton_ydl5f"};
require('./index.css')

var invertedColors = {"clearIcon":"input__clearIcon_1r2k2"};
require('./inverted.css')

var colorStyles = {
    default: defaultColors,
    inverted: invertedColors,
};
var preventDefault = function (e) { return e.preventDefault(); };
var ClearButton = function (_a) {
    var colors = _a.colors, disabled = _a.disabled, onClick = _a.onClick, dataTestId = _a.dataTestId;
    return (React.createElement(Button, { type: 'button', view: 'text', disabled: disabled, "aria-label": '\u041E\u0447\u0438\u0441\u0442\u0438\u0442\u044C', className: styles.clearButton, onClick: onClick, tabIndex: -1, onMouseDown: preventDefault, dataTestId: dataTestId },
        React.createElement(CrossCircleMIcon, { className: cn(styles.clearIcon, colorStyles[colors].clearIcon) })));
};

export { ClearButton };
